module.exports = __webpack_public_path__ + "img/people.895606b5.jpg";